<ion-header>
  <ion-toolbar>
    <ion-title>Add Can</ion-title>
    <ion-buttons slot="end">
      <ion-button (click)="closeModal()">
        <ion-icon slot="icon-only" name="close"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content [formGroup]="form">
  <ion-card class="ion-no-padding">
    <ion-item lines="none">
      @if (cans) {
        <ion-select
          label="Select Size"
          labelPlacement="floating"
          formControlName="selectCan"
          (ionChange)="selectItem($event)"
          placeholder="Select size"
          interface="popover"
          data-testid="new-can-size-select"
          #addKegSelectList
          >
          @for (can of cans; track can) {
            <ion-select-option [value]="can">
              {{ can.name }}
            </ion-select-option>
          }
        </ion-select>
      }
    </ion-item>
  </ion-card>
</ion-content>
